<template>
  <container-small>
    <background-wrapper src="policy-header" ext="png">
      <div class="hero">
        <text-container size="lg">
          <h2 v-html="$t(`${$route.name}.header.title`)"/>
          <p v-html="$t(`${$route.name}.header.subTitle`)"/>
        </text-container>
      </div>
    </background-wrapper>
  </container-small>
</template>
<script>
export default {
  name: 'Accessibility'
}
</script>

<style lang="sass" scoped>
.hero
  padding: 100px 0
  +media-breakpoint-down(sm)
    padding: 100px 0
    p
      width: 90%

  .text-container
    text-align: left!important
    justify-items: start!important
    max-width: 550px
    +media-breakpoint-down(md)
      max-width: 65vw
</style>



// WEBPACK FOOTER //
// src/components/ui/PolicyHeader.vue